import { createSlice } from '@reduxjs/toolkit'
import { RootState, AppThunk } from './store'
import { get } from '../utils/rest'
import { LoginPage, Footer, AvailableTags } from 'types/types'
import * as Toast from 'components/Toast'

export interface SettingsState {
  isLoading: boolean
  settings: Settings | null
}

export interface Settings {
  loginPage: LoginPage | null
  artForms: string[]
  footer: Footer | null
  availableTags: AvailableTags
  numberOfSearchHitsPerPage: number
  loginPermaLink: string
}

const createInitialState = (): SettingsState => {
  return {
    isLoading: false,
    settings: null,
  }
}

export const settingsSlice = createSlice({
  name: 'settings',
  initialState: createInitialState(),
  reducers: {
    beginSiteSettingsFetch: (state) => {
      state.isLoading = true
    },
    fetchSiteSettingsSuccess: (state, action) => {
      state.settings = action.payload
      state.isLoading = false
    },
  },
})

export const { beginSiteSettingsFetch, fetchSiteSettingsSuccess } = settingsSlice.actions

export const loadSiteSettingsAsync = (): AppThunk => async (dispatch) => {
  dispatch(beginSiteSettingsFetch())
  try {
    const response = await get<Settings>(`/api/settings/site/`)
    if (response.status === 200 && response.parsedBody?.data) {
      dispatch(fetchSiteSettingsSuccess(response.parsedBody?.data))
    } else {
      Toast.dispatchToastError({ message: response.parsedBody?.message ?? 'Det gick inte att hämta inställningar' })
    }
  } catch (e) {
    Toast.dispatchToastError({ message: 'Det gick inte att hämta inställningar' })
  }
}

export const selectSiteState = (state: RootState): SettingsState => state.settings
export const selectLoginPage = (state: RootState): LoginPage | null | undefined => state.settings.settings?.loginPage
export const selectNumberOfHitsPerPage = (state: RootState): number =>
  state.settings.settings?.numberOfSearchHitsPerPage as number
export const selectArtForms = (state: RootState): string[] | undefined => state.settings.settings?.artForms
export const selectFooter = (state: RootState): Footer | null | undefined => state.settings.settings?.footer
export const selectTags = (state: RootState): string[] => state.settings.settings?.availableTags?.tags as string[]
export const selectLoginPagePermaLink = (state: RootState): string | null | undefined =>
  state.settings.settings?.loginPermaLink

export default settingsSlice.reducer
